import React from 'react';
import './ProductStyle.css';

const StraightenedWiresBars = ({ open,onClose }) => {
    

    if(!open) return null
    return (
        <div className='overlay'>
            <div className='proContainer'>
                <button onClick={onClose} className='closeBtn'>X</button>
                <p> Straightened Wires Bars</p>
                <div className='specs'>
                    <ul>
                        <li>Raw Material: <div>Low Carbon steel</div></li>
                        <li>Dimensions Range: <div>⌀1mm - ⌀13mm</div></li>
                        <li>Surface Quality: <div>Bright suitable for enamel, nickel plating, galvanizing or painting</div></li>
                        <li>Packing: <div>30cm - 400cm</div></li>
                        
                    </ul>
                </div>
                
            </div>
        </div>
    );
}

export default StraightenedWiresBars;
